export enum ProcedureEnhancementState {
  NotEnhanced = 0,
  InProgress = 1,
  Enhanced = 2
}
